<template>
  <div class="brandManagePage">
    <div class="classBox">
      <div class="classItem" :class="{'isActive':index==selClass}" v-if="item.children.length>0" v-for="(item,index) in classList" @click="changeClass(index)" :key="index">
        {{item.text}}
        <i class="el-icon-caret-right" v-if="index==selClass" style="font-size: larger"></i>
      </div>
    </div>
    <div class="brandManageContent">
      <el-card class="box-card" style="min-height: 40px">
        <el-input placeholder="请输入内容" v-model="searchcontent" size="mini" style="width:260px;margin-bottom: 10px">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input><br>
        已选择：<template  v-for="(item,index) in brandList">
        <el-tag size="mini" effect="plain" v-if="child.isActive" :key="child.id" v-for="(child,childIndex) in item.children">{{child.text}}</el-tag>
      </template>
      </el-card>
      <el-card class="box-card" v-for="(item,index) in brandList" :key="index">
        <div slot="header" class="clearfix">
          <span>{{item.text}}</span>
          <el-button  style="float: right; padding: 3px 0;width:140px;height:28px" size="mini"
                   v-if="checkID=='002'||checkID=='003'||checkID=='004'"   type="success" plain @click="addNewBrand(item)">增加镜架类品牌</el-button>
        </div>
        <el-button :loading="loading" :icon="child.isActive?'el-icon-check':'el-icon-shopping-cart-2'"
                   plain :type="child.isActive?'primary':'info'" v-for="(child,childIndex) in item.children" :key="childIndex" @click="chooseItem(child)"
                   v-if="child.text.indexOf(searchcontent)>-1"
         style="margin-bottom: 10px">{{child.text}}</el-button>
     </el-card>
      <!--<el-button type="text" v-if="selClass==0" class="addBrand" @click="addGrassBrand">镜片品牌不全？点击上传价格表照片</el-button>-->
      <!--<el-button type="text" v-else class="addBrand" @click="addNewBrand">镜架品牌不全？点击添加镜架品牌</el-button>-->
    </div>
    <BrandAdd ref="BrandAdd" @bindGrid="bindTable"></BrandAdd>
    <GrassAdd ref="GrassAdd"></GrassAdd>
  </div>
</template>

<script>
import BrandAdd from './BrandAdd.vue'
import GrassAdd from './GrassAdd.vue'
import {getGoodsTree} from '@/api/set/jxcgooddetail';
import {listGoodsRight,batchsaveGoodsRight,removeGoodsRight} from '@/api/set/jxcgoodscategory'

export default {
  components: { BrandAdd, GrassAdd },
  data() {
    return {
      checkID:'',
      selClass: 0,
      loading:false,
      checkClass:[],
      classList: [],
      searchcontent:'',
      brandList: [],
      selectItems:[]
    }
  },
  methods: {
    bindTable(init) {
      //分类数据
      getGoodsTree({
        onlyShowEnabledGroupType: true,
        onlyShowGroupType: true,
        maxlenght: 9,
        allcat: '9'
      }).then(response => {
        var classL = response.data.obj;

        //已选择的品牌
        listGoodsRight({}).then(response => {
          this.checkClass = response.data.obj;
          for (let i in classL) {
            for (let j in classL[i].children) {
              for (let m in classL[i].children[j].children) {
                var row = classL[i].children[j].children[m]

                for (let c in this.checkClass) {
                  if (this.checkClass[c].categorycode == row.id) {
                    row.isActive = true;
                    break;
                  }
                }
              }
            }
          }
          this.classList = classL;
          this.changeClass(init ? 0 : this.selClass);
        });

      });


    },
    changeClass(index) {
      this.selClass = index;
      this.checkID = this.classList[index].id;
      this.brandList = this.classList[index].children;
    },
    addNewBrand(item) {
      this.$refs.BrandAdd.show(item);
    },
    addGrassBrand() {
      this.$refs.GrassAdd.show();
    },
    finishFn(callback) {
      if (callback) {
        callback(true);
      }
    },
    chooseItem(brand) {
      this.loading = true;
      if (brand.isActive) {//删除
        removeGoodsRight({categorycodes: brand.id}).then(response => {
          this.loading = false;
          if (response.data.code == 0) {
            this.$set(brand, 'isActive', false);
          } else {
            this.$message({
              type: 'error',
              message: response.data.msg
            });
          }
        })
      } else {//增加
        batchsaveGoodsRight({categorycodes: brand.id}).then(response => {
          this.loading = false;
          this.$set(brand, 'isActive', true);
        })
      }
    }
  },
  mounted() {
    this.bindTable(true);
  },
}
</script>
<style  scoped>
  .brandManagePage{
    display: flex;
    border: 0px solid #ccc;
  }

  .brandManagePage .classBox{
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 15%;
    background: #eaf4ff;
    padding: 0px 0;
    color: #333;
    height: 100%;
    overflow: auto;
  }

  .brandManagePage .brandManageContent {
    padding: 0px 15px 0px 15px;
    width: 85%;
    margin: 0 auto;
    height: 100%;
    overflow: auto;
  }

  .classItem.isActive {
    color: #3e96f7;
  }

  .classItem {
    cursor: pointer;
    padding: 0 27px 0 30px;
    position: relative;
    text-align: left;
    font-size: 16px;
    height: 42px;
    line-height: 42px;
  }


  .box-card {
    width: 100%;
    margin-left: 0px;
    margin-bottom: 25px;
    min-height: 180px;
    text-align: left;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .clearfix span{
    float:left;
    font-weight:600;
    font-size:14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/childComp/BrandManage.vue